/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { JobResponseWithTask } from '../models/JobResponseWithTask';
import type { QuoteCreateJobRequest } from '../models/QuoteCreateJobRequest';
import type { QuoteEligibilityForm } from '../models/QuoteEligibilityForm';
import type { QuoteEligibilityRequest } from '../models/QuoteEligibilityRequest';
import type { QuoteEligibilityResponse } from '../models/QuoteEligibilityResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class QuoteRoutesRepository {
  /**
   * Get Quote Eligibility Form
   * Start a quick quote: the blank eligibility form for the current contractor's registered programs.
   * @returns QuoteEligibilityForm Successful Response
   * @throws ApiError
   */
  public static quoteRoutesGetQuoteEligibilityForm({
    authorization,
  }: {
    authorization?: string,
  }): CancelablePromise<QuoteEligibilityForm> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/quotes/eligibility',
      headers: {
        'authorization': authorization,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Check Quote Eligibility
   * Check stubbed eligibility for the requested programs: one eligible evaluation per program.
   * @returns QuoteEligibilityResponse Successful Response
   * @throws ApiError
   */
  public static quoteRoutesCheckQuoteEligibility({
    requestBody,
    authorization,
  }: {
    requestBody: QuoteEligibilityRequest,
    authorization?: string,
  }): CancelablePromise<QuoteEligibilityResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/quotes/eligibility',
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Create Job From Quote
   * Create a job from a previously-evaluated quick quote's answers, for the selected programs.
   * @returns JobResponseWithTask Successful Response
   * @throws ApiError
   */
  public static quoteRoutesCreateJobFromQuote({
    requestBody,
    authorization,
  }: {
    requestBody: QuoteCreateJobRequest,
    authorization?: string,
  }): CancelablePromise<JobResponseWithTask> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/quotes/jobs',
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        422: `Validation Error`,
      },
    });
  }
}
